import { render, staticRenderFns } from "./MainPricing.vue?vue&type=template&id=10bedf26&scoped=true&"
import script from "./MainPricing.vue?vue&type=script&lang=ts&"
export * from "./MainPricing.vue?vue&type=script&lang=ts&"
import style0 from "./MainPricing.vue?vue&type=style&index=0&id=10bedf26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bedf26",
  null
  
)

export default component.exports